export default {"src":"/_next/static/media/care.287f7ce6.svg","height":140,"width":140,"blurWidth":0,"blurHeight":0};